import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { shouldRetry } from "src/api/client";
import { App } from "src/app";
import "src/index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Neither refusal is retried: a 401 would just delay the login redirect, and
      // a forbidden read will never succeed either. The predicate lives in
      // client.ts, next to the two classes it switches on and where a test can
      // reach it.
      retry: shouldRetry,
      refetchOnWindowFocus: false,
      staleTime: 30_000
    }
  }
});

const root = document.getElementById("root");
if (!root) {
  throw new Error("no #root element");
}

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>
);
